import { render, staticRenderFns } from "./StarthousePage.vue?vue&type=template&id=0f334f4f&scoped=true&"
import script from "./StarthousePage.vue?vue&type=script&lang=js&"
export * from "./StarthousePage.vue?vue&type=script&lang=js&"
import style0 from "./StarthousePage.vue?vue&type=style&index=0&id=0f334f4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f334f4f",
  null
  
)

/* custom blocks */
import block0 from "./StarthousePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports